import React from "react";
import { injectIntl } from "react-intl";

import {
  Row,
  List,
  Loader,
  ActionBar,
  ActionBarButtons,
  CreateActionButton,
  Container,
  intlShape,
  withApi,
  apiShape,
  withNotifier,
  notifierShape,
  SearchBar,
  isTouchDevice,
  Column,
} from "lcm-iot-commons";
import ResellerCustomerItem from "./ResellerCustomerItem";

type Props = {
  api: apiShape;
  intl: intlShape;
  notifier: notifierShape;
};

export function ResellerCustomers({ api, intl, notifier }: Props) {
  const [customers, setCustomers] = React.useState();
  const [badge, setBadge] = React.useState(
    <span className="loading">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>,
  );

  const loadData = async (searchTerm = "") => {
    try {
      const response = await api.getAll("/customers", {
        number: `*${searchTerm}*`,
      });
      setBadge(response.pagination?.total_count);
      setCustomers(response.customers);
    } catch (error) {
      notifier.showError(api.translateError(error));
      // @ts-expect-error TS(2345) FIXME: Argument of type 'never[]' is not assignable to pa... Remove this comment to see the full error message
      setCustomers([]);
      // @ts-expect-error TS(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      setBadge(0);
    }
  };
  React.useEffect(() => {
    loadData();
  }, []);

  const handleOnSearch = (searchTerm: $TSFixMe) => {
    loadData(searchTerm);
  };

  const removeCustomer = (customerId: $TSFixMe) => {
    setCustomers(
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      customers.filter((customer: $TSFixMe) => customer.id !== customerId),
    );
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    setBadge(customers.length - 1);
  };

  return (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            <h1 id="reseller-customers-header">
              {intl.formatMessage({ id: "reseller_customers.header" })}
              <span id="customers-count" className="badge">
                {badge}
              </span>
            </h1>
            <ActionBarButtons>
              <CreateActionButton
                // @ts-expect-error TS(2322) FIXME: Type '{ id: string; target: string; }' is not assi... Remove this comment to see the full error message
                id="create-customer-button"
                target="/reseller/customers/create"
              />
            </ActionBarButtons>
          </ActionBar>
          <SearchBar
            // @ts-expect-error TS(2322) FIXME: Type '{ autoFocus: boolean; filterWildcard: boolea... Remove this comment to see the full error message
            autoFocus={!isTouchDevice()}
            filterWildcard={false}
            minChars={1}
            onSearch={handleOnSearch}
            placeholder={intl.formatMessage({
              id: "reseller_customers.search_placeholder",
            })}
            resettable
            timeout={300}
          />
          {customers && (
            <List id="reseller-customers-list">
              {(customers as $TSFixMe).map((customer: $TSFixMe) => (
                <ResellerCustomerItem
                  key={customer.id}
                  customer={customer}
                  removeCustomer={removeCustomer}
                />
              ))}
            </List>
          )}
          {!customers && <Loader />}
        </Column>
      </Row>
    </Container>
  );
}

export default injectIntl(withApi(withNotifier(ResellerCustomers)));
